import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom'
import { ChakraProvider } from "@chakra-ui/react"
import { Provider } from 'jotai';
//import * as serviceWorker from './serviceWorker';



ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={'una-rosa-per-maria'}>
          <Provider>
            <ChakraProvider>   
                <App />
            </ChakraProvider>
          </Provider>
        </BrowserRouter>
    </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//serviceWorker.register();
